export default {
  previous: 'Previous',
  next: 'Next',
  goToPage: 'Go to page',
  goToPreviousPage: 'Go to previous page',
  goToNextPage: 'Go to next page',
  currentPage: 'Current page',
  showing: 'Showing',
  items: 'items',
  itemsPerPage: 'Items per page',
  sortBy: 'Sort by',
  orderBy: {
    nameAsc: 'Name (A-Z)',
    nameDesc: 'Name (Z-A)',
    dateAsc: 'Date (Oldest)',
    dateDesc: 'Date (Newest)'
  }
};
